import { Button, Form, Input, Modal, Radio, Select } from "antd";
import React from "react";
import { FC } from "react";
import DateInput from "../../../../utils/DateInput";

interface IModal {
  open: boolean;
  setOpen: any;
  stateInitial: any;
  principalState: any;
  setPrincipalState: any;
  adicionarActividad: any;
  actividadesSeleccionadas: any[];
}

const ModalCronograma: FC<IModal> = ({
  open,
  setOpen,
  stateInitial,
  principalState,
  setPrincipalState,
  adicionarActividad,
  actividadesSeleccionadas,
}) => {
  // fields
  const fields = [
    { name: "actividad", value: principalState.actividad },
    { name: "rango_fechas", value: principalState.rango_fechas },
    { name: "fechainicio", value: principalState.fechainicio },
    { name: "fechafinal", value: principalState.fechafinal },
    { name: "hora_cierre", value: principalState.hora_cierre },
    { name: "hora", value: principalState.hora },
    { name: "minuto", value: principalState.minuto },
    { name: "formato", value: principalState.formato },
  ];

  const [value, setValue] = React.useState(1);

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const seleccionarActividad = (event, result) => {
    let seleccionada = actividadesSeleccionadas.filter(
      (data) => data.text === result.value
    );
    if (seleccionada && seleccionada.length > 0)
      setPrincipalState({ ...principalState, actividad: seleccionada[0].text });

  };

  return (
    <Modal
      title="Selecciona la actividad"
      visible={open}
      onCancel={() => {
        setPrincipalState(stateInitial);
        setOpen(false);
      }}
      width={900}
      footer={[
        <Button key="b_cancelar_modal_cronograma"
          className="button-gray-ghost"
          onClick={() => {
            setPrincipalState(stateInitial);
            setOpen(false);
          }}
        >
          Cancelar
        </Button>,
        <Button key="b_aceptar_modal_cronograma"
          className="button-azul-radius"
          htmlType="submit"
          form="documentosconvocatoriaeditardocumentosbeps"
        >
          Asignar actividades
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="container-fluid">
        <div className="row">
          <Form
            name="documentosconvocatoriaeditardocumentosbeps"
            size="large"
            layout="vertical"
            className="width-100"
            onFinish={adicionarActividad}
            fields={fields}
            onFieldsChange={(_, fields: any) => { }}
          >
            <div className="row">
              <div className="col-12">
                <Form.Item
                  // className="no-margin"
                  label="Lista de actividades"
                  name="actividad"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Select
                    placeholder="Seleccionar..."
                    onChange={seleccionarActividad}
                  >
                    {actividadesSeleccionadas.map(({ value, text }) => (
                      <Select.Option key={value} value={text}>
                        {text}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-12 col-md-3">
                <Form.Item
                  // className="no-margin"
                  label="Rango de fechas"
                  name="rango_fechas"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Radio.Group
                    onChange={(e) =>
                      setPrincipalState({
                        ...principalState,
                        rango_fechas: e.target.value,
                      })
                    }
                    value={value}
                  >
                    <Radio value={"si"}>Si</Radio>
                    <Radio value={"no"}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <Form.Item
                  className="no-margin"
                  label="Fecha inicio"
                  name="fechainicio"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <DateInput
                    save={(fecha) => {
                      setPrincipalState({
                        ...principalState,
                        fechainicio: fecha,
                        fechafinal:fecha,
                      });
                    }}
                    dia={principalState.fechainicio.split("-")[2] || ""}
                    mes={principalState.fechainicio.split("-")[1] || ""}
                    anio={principalState.fechainicio.split("-")[0] || ""}
                  />
                </Form.Item>
              </div>
              {principalState.rango_fechas === "si" && (
                <div className="col-12 col-md-6 col-lg-4">
                  <Form.Item
                    className="no-margin"
                    label="Fecha fin"
                    name="fechafinal"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <DateInput
                      save={(fecha) => {
                        setPrincipalState({
                          ...principalState,
                          fechafinal: fecha,
                        });
                      }}
                      dia={principalState.fechafinal.split("-")[2] || ""}
                      mes={principalState.fechafinal.split("-")[1] || ""}
                      anio={principalState.fechafinal.split("-")[0] || ""}
                    />
                  </Form.Item>
                </div>
              )}
              <div className="row">
                <div className="col-12 col-md-3">
                  <Form.Item
                    label="Hora de cierre"
                    name="hora_cierre"
                    rules={[{ required: true, message: "Campo obligatorio" }]}
                  >
                    <Radio.Group
                      onChange={(e) =>
                        setPrincipalState({
                          ...principalState,
                          hora_cierre: e.target.value,
                        })
                      }
                      value={value}
                    >
                      <Radio value={"si"}>Si</Radio>
                      <Radio value={"no"}>No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
                {principalState.hora_cierre === "si" && (
                  <div className="col-12 col-md-6 p-0">
                    <div>
                      <div className="row">
                        <div className="col-3 column-without-padding-rigth">
                          <label className="pb-3">Hora {
                              principalState.hora < 12 ? "AM" : "PM"
                            }</label>
                          <Input
                            type="number"
                            placeholder="HH"
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(
                                /\D/,
                                ""
                              );
                              //   if (e.target.value > 12) {
                              //     e.target.value = "";
                              //   }
                              setPrincipalState({
                                ...principalState,
                                hora: e.target.value,
                              });
                            }}
                            max={24}
                            // maxLength="2"
                            // fluid
                            value={principalState.hora}
                          />
                        </div>
                        <div className="col-3 column-without-padding-rigth">
                          <label className="pb-3">Minutos</label>
                          <Input
                            placeholder="mm"
                            onChange={(e) => {
                              e.target.value = e.target.value.replace(
                                /\D/,
                                ""
                              );
                              //   if (e.target.value > 60) {
                              //     e.target.value = "";
                              //   }
                              setPrincipalState({
                                ...principalState,
                                minuto: e.target.value,
                              });
                            }}
                            // maxLength="2"
                            max={60}
                            type="number"
                            // fluid
                            value={principalState.minuto}
                          />
                        </div>

                        {/* <div className="col-6">
                          <Form.Item
                            label="Hora de cierre"
                            name="formato"
                            rules={[
                              {
                                required: true,
                                message: "Campo obligatorio",
                              },
                            ]}
                          >
                            {/* <Radio.Group
                              onChange={(e) =>
                                setPrincipalState({
                                  ...principalState,
                                  formato: e.target.value,
                                })
                              }
                              value={value}
                            >
                              {/* <Radio value={1}>AM</Radio>
                              <Radio value={2}>PM</Radio> 
                            </Radio.Group> 
                          </Form.Item>
                        </div> */}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default ModalCronograma;
